import { type TimeSlot } from "../../Shifts/types";
import { type ShiftBoardShift } from "../types";

const PRIORITIES = {
  UNFILLED: 1,
  FILLED: 2,
  VERIFIED: 3,
  CANCELLED: 4,
} as const;

function filterShiftsByTimeSlot(shifts: ShiftBoardShift[], timeSlot: TimeSlot): ShiftBoardShift[] {
  return shifts.filter((shift) => shift.timeslot === timeSlot);
}

function getShiftPriority(shift: ShiftBoardShift): number {
  if (shift.deleted || !shift.isBillable) {
    return PRIORITIES.CANCELLED;
  }

  if (shift.verified) {
    return PRIORITIES.VERIFIED;
  }

  if (!shift.worker) {
    return PRIORITIES.UNFILLED;
  }

  return PRIORITIES.FILLED;
}

export function sortShiftsByPriority(shifts: ShiftBoardShift[]): ShiftBoardShift[] {
  return shifts.sort((a, b) => {
    const priorityA = getShiftPriority(a);
    const priorityB = getShiftPriority(b);

    if (priorityA !== priorityB) {
      return priorityA - priorityB;
    }

    return new Date(a.start).getTime() - new Date(b.start).getTime();
  });
}

export function filterAndSortShifts(
  shifts: ShiftBoardShift[],
  timeSlot: TimeSlot
): ShiftBoardShift[] {
  const filteredShifts = filterShiftsByTimeSlot(shifts, timeSlot);
  return sortShiftsByPriority(filteredShifts);
}
